import { render } from "./partnersListing.vue?vue&type=template&id=27604096&scoped=true"
import script from "./partnersListing.vue?vue&type=script&lang=js"
export * from "./partnersListing.vue?vue&type=script&lang=js"

import "./partnersListing.vue?vue&type=style&index=0&id=27604096&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27604096"]])

export default __exports__